<template>
  <div
    class="progress-pie-chart"
    :class="[soldPercentage > 50 ? 'gt-50' : '']"
    :data-percent="soldPercentage"
    v-if="!isNaN(soldPercentage) && soldPercentage >= 60"
  >
    <div class="ppc-progress">
      <div
        class="ppc-progress-fill"
        :style="{ transform: `rotate(${(360 * soldPercentage) / 100}deg)` }"
      ></div>
    </div>
    <div class="ppc-percents">
      <div class="pcc-percents-wrapper">
        <h5 class="ppc-percents-content">
          <span class="font-bold sold-percentage">{{ soldPercentage }}%</span>
          <span class="font-semibold d-block sold-text">sold</span>
        </h5>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from "vue";

const props = defineProps<{
  soldPercentage: number;
}>();
const { soldPercentage } = toRefs(props);
</script>

<style lang="scss" scoped>
$size: 40px;

@mixin circle($size) {
  content: "";
  position: absolute;
  border-radius: 50%;
  left: calc(50% - #{$size/2});
  top: calc(50% - #{$size/2});
  width: $size;
  height: $size;
}

.progress-pie-chart {
  width: $size;
  height: $size;
  border-radius: 50%;
  background-color: #d9d9d9ba;
  position: relative;
  margin-left: auto;

  &.gt-50 {
    background-color: #b16956;
  }
}

.ppc-progress {
  @include circle($size);
  clip: rect(0, $size, $size, #{$size/2});

  .ppc-progress-fill {
    @include circle($size);
    clip: rect(0, #{$size/2}, $size, 0);
    background: #b16956;
    transform: rotate(60deg);
  }

  .gt-50 & {
    clip: rect(0, #{$size/2}, $size, 0);

    .ppc-progress-fill {
      clip: rect(0, $size, $size, #{$size/2});
      background: #e5e5e5;
    }
  }
}

.ppc-percents {
  @include circle(#{$size/1.22});
  background: $white;
  text-align: center;
  display: table;
}

.ppc-percents-content {
  color: #b16956;
  line-height: 1;

  .sold-percentage {
    font-size: 10px;
  }

  .sold-text {
    font-size: 9px;
  }
}

.pcc-percents-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>
